import AuthService from '../../utilities/services/auth.service'

import { AccountingDashboardWrapper } from '../../components'

export default function AccountingDashboardPage() {
  const organization = AuthService.getOrg()[0]

  return <AccountingDashboardWrapper organization={organization} />
}
